module.exports = __webpack_public_path__ + "portrait-boy.b17a77d.png";